import { curry, merge } from 'lodash/fp';
/**
 * @deprecated
 * Inject custom props into selector
 *
 * @param {object} newProps - custom props to be injected into selector invokation
 * @param {Function} selector - initial selector to be modified
 *
 * @returns {Function} selector - modified selector with injected props
 *
 * @example
 * injectProps({ form: FORM_ID }, valuesSelector)
 */

export var injectProps = curry(function (newProps, selector) {
  return function (state, props) {
    return selector(state, merge(props, newProps));
  };
});
export default injectProps;